import { ICloudinaryResponse } from './uploadFile';
import ExifReader from 'exifreader';

// Extract public id from the URL. Its always after /image/upload/ and before the file extension (so just look for the next '.')
const PUBLIC_ID = /\/image\/upload\/([^\.]+)/;

export async function mapS3PhotoToCloudinaryResponse(
  s3UploadUrl: string,
  uploadedFile: File,
): Promise<ICloudinaryResponse> {
  const publicId = s3UploadUrl.match(PUBLIC_ID)?.[1];

  const timestamp = Math.floor(Date.now() / 1000);

  // This can throw an error if an invalid image file is selected.
  // This will be caught by upstream components and render an error message to the user:
  // "There was a problem uploading your image. Please make sure your image is a .jpg, .png or .heic format and try again."
  const exifReaderTags = await ExifReader.load(uploadedFile);

  // There are different exif tag names for height and width.
  // I'm not sure when one would be available and the other would not, so check both.
  const height = exifReaderTags.ImageHeight?.value || exifReaderTags['Image Height']?.value;
  const width = exifReaderTags.ImageWidth?.value || exifReaderTags['Image Width']?.value;

  // The default of 'jpg' aligns with the default extension that Reverb::Image::Upload sets in core
  const format = uploadedFile.name.split('.').pop() || 'jpg';

  return {
    public_id: publicId,
    format,
    resource_type: 'image',
    original_filename: uploadedFile.name,
    version: timestamp,
    height,
    width,
  };
}
